/* eslint-disable react/jsx-props-no-multi-spaces */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';

import 'react-image-lightbox/style.css';
import './Images.css';

function Images(props) {
  const { viewportWidth, bilderdaten } = props;

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  function handleOpen(index) {
    setPhotoIndex(index);
    setIsOpen(true);
  }

  return (
    <>
      <div
        className={
          viewportWidth > 768 ? 'bilder-container' : 'bilder-container-mobil'
        }
      >
        {bilderdaten.map((value, index) => (
          <button
            type="button"
            className="bilder-container-style"
            onClick={() => handleOpen(index)}
          >
            <img
              className={
                viewportWidth > 768 ? 'slider-bilder' : 'slider-bilder-mobil'
              }
              key={value}
              src={`https://hdm-stuttgart.de/mediathek${
                value[index % value.length]
              }`}
              alt={`Bildergalerie Bild Nr. ${index}`}
            />
          </button>
        ))}
      </div>
      {isOpen && (
        <Lightbox
          mainSrc={`https://hdm-stuttgart.de/mediathek${
            bilderdaten[photoIndex]
          }`}
          nextSrc={`https://hdm-stuttgart.de/mediathek${
            bilderdaten[(photoIndex + 1) % bilderdaten.length]
          }`}
          prevSrc={`https://hdm-stuttgart.de/mediathek${
            bilderdaten[
              (photoIndex + bilderdaten.length - 1) % bilderdaten.length
            ]
          }`}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex(
            (photoIndex + bilderdaten.length - 1) % bilderdaten.length,
          )}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % bilderdaten.length)}
          imageLoadErrorMessage="Dieses Bild kann leider nicht angezeigt werden."
          onImageLoadError={() => setIsOpen(false)}
        />
      )}
    </>
  );
}

export default Images;

Images.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  bilderdaten: PropTypes.array.isRequired,
  viewportWidth: PropTypes.number.isRequired,
};
